import { FAQ } from 'components/faq';
const FAQContainer = FAQ;
export { FAQContainer };
